import { Injectable } from '@angular/core';
import { IAirCreateBookingRequest, IAirCreateBookingRequestPayment } from "libraries/service/resources/model/booking/air/IAirCreateBooking";
import { IAirTotal } from "libraries/service/resources/model/search/air/IAirTotal";
import { IQuote } from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import { ResponseForConvertOfferAfx2jsonType } from "@afidium/ts-facade";
import _cloneDeep from "lodash-es/cloneDeep";

@Injectable({providedIn: "root"})
export class AirBookingCreatePaymentService {

    private storedPayment: IAirCreateBookingRequestPayment;

    public setPayment(payment: IAirCreateBookingRequestPayment): void {
        this.storedPayment = payment;
    }

    public getPayment(): IAirCreateBookingRequestPayment {
        return this.storedPayment;
    }

    public resetPayment(): void {
        this.storedPayment = null;
    }

    public extractFullTotalPriceFromServiceSelection(serviceSelection: any): { amount: string, value: number, currencyCode: string } {
        const cost: any = serviceSelection.offer.total.cost;

        const fullTotal: any = cost.totalArray
            .find((total: any): boolean => !total.xReason);

        const defaultCurrencyCode: string = serviceSelection.currencyArray
            .find((currencyItem: any): boolean => currencyItem._default || currencyItem.default).currencyCode;

        return fullTotal.currencyArray
            .find((currencyItem: any): boolean => currencyItem.currencyCode === defaultCurrencyCode);
    }

    /**
     *  compute payment for RQ
     */
    public computePayment(booking: Partial<IQuote>, sqaRequest: ResponseForConvertOfferAfx2jsonType, serviceSelection?: any): IAirCreateBookingRequestPayment {
        const price: any = booking.total.find((totalItem: IAirTotal): boolean => {
            return totalItem.xType === 'cost';
        });

        const value: number = Boolean(serviceSelection) ?
            this.extractFullTotalPriceFromServiceSelection(serviceSelection).value :
            price.value;
        const amount: string = Boolean(serviceSelection) ?
            this.extractFullTotalPriceFromServiceSelection(serviceSelection).amount :
            price.amount;
        const currencyCode: string = Boolean(serviceSelection) ?
            this.extractFullTotalPriceFromServiceSelection(serviceSelection).currencyCode :
            price.currencyCode ?? price.currency;

        return {
            formOfPayment: {
                // @ts-ignore
                card: {
                    xIs: "VirtualCard"
                },
                ...sqaRequest?.payment?.formOfPayment
            },
            price: {
                // @ts-ignore
                cost: {
                    currency: {
                        currencyCode,
                        decimals: price.decimals,
                        value,
                        amount,
                    }
                }
            }
        };
    }
}
